/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import advantagesLegalbirdAttorneySectionStyle from "./advantagesLegalbirdAttorneySectionStyle";
import ContainerFullWidth from "../../../Container/ContainerFullWidth";
import Grid from "@mui/material/Grid";
import CallClockIcon from "../../../../assets/icons/generic/IconCallClock";
import AttorneyIcon from "../../../../assets/icons/generic/IconLaywer";
import MobileDesktopIcon from "../../../../assets/icons/landingpage/IconMobileDesktop";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

type AdvantagesLegalbirdAttorneySectionProps = {
  product?: string;
  heading?: string;
};

const AdvantagesLegalbirdAttorneySection = ({
  product = "divorce",
  heading = "Vorteile bei den Legalbird Rechtsanwälten",
}: AdvantagesLegalbirdAttorneySectionProps) => {
  let areaOfLaw = "Familienrecht";
  switch (product) {
    default:
    case "divorce":
      areaOfLaw = "Familienrecht";
      break;
    case "settlement":
      areaOfLaw = "Arbeitsrecht";
      break;
    case "traffic":
      areaOfLaw = "Verkehrsrecht";
  }

  return (
    <ContainerFullWidth sectionPadding={false} sx={advantagesLegalbirdAttorneySectionStyle.container}>
      <Box sx={advantagesLegalbirdAttorneySectionStyle.scrollToAnchor} id="legalbird-vorteile" />
      <Typography variant={"h2"} sx={advantagesLegalbirdAttorneySectionStyle.title}>
        {heading}
      </Typography>
      <Grid container>
        <Grid
          sx={advantagesLegalbirdAttorneySectionStyle.gridItem}
          size={{
            xs: 12,
            sm: 12,
            md: 4
          }}>
          <Box sx={advantagesLegalbirdAttorneySectionStyle.imageContainer}>
            <CallClockIcon sx={advantagesLegalbirdAttorneySectionStyle.iconImage}/>
          </Box>
          <Typography variant={"h4"} sx={advantagesLegalbirdAttorneySectionStyle.advantageTitle}>
            Keine Wartezeiten
          </Typography>
          <Typography sx={advantagesLegalbirdAttorneySectionStyle.description}>
            Schnelle und persönliche Beratung per Telefon, E-Mail und falls nötig auch vor Ort
          </Typography>
        </Grid>
        <Grid
          sx={advantagesLegalbirdAttorneySectionStyle.gridItem}
          size={{
            xs: 12,
            sm: 12,
            md: 4
          }}>
          <Box sx={advantagesLegalbirdAttorneySectionStyle.imageContainer}>
            <AttorneyIcon sx={advantagesLegalbirdAttorneySectionStyle.iconImage}  />
          </Box>
          <Typography variant={"h4"} sx={advantagesLegalbirdAttorneySectionStyle.advantageTitle}>
            Erfahrene Fachanwälte
          </Typography>
          <Typography sx={advantagesLegalbirdAttorneySectionStyle.description}>Wir sind hochqualifizierte Anwälte im {areaOfLaw}</Typography>
        </Grid>
        <Grid
          sx={advantagesLegalbirdAttorneySectionStyle.gridItem}
          size={{
            xs: 12,
            sm: 12,
            md: 4
          }}>
          <Box sx={advantagesLegalbirdAttorneySectionStyle.imageContainer}>
            <MobileDesktopIcon sx={advantagesLegalbirdAttorneySectionStyle.iconImage} />
          </Box>
          <Typography variant={"h4"} sx={advantagesLegalbirdAttorneySectionStyle.advantageTitle}>
            Alles online
          </Typography>
          <Typography sx={advantagesLegalbirdAttorneySectionStyle.description}>
            Alle Informationen und Dokumente sind jederzeit und überall online aufrufbar
          </Typography>
        </Grid>
      </Grid>
    </ContainerFullWidth>
  );
};

export default AdvantagesLegalbirdAttorneySection;
